<div class="container">

    <h2>Access denied</h2>
    
    <p>You not have access to this page. <i>Sie haben aktuell keinen Zugriff zu dieser Seite.</i></p>
    
    <p><a routerLink="/login">Go to start page.</a>&nbsp;<i><a routerLink="/login">Zur Startseite wechseln.</a></i></p>
    
</div>